module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-100.32d3abc4.svg";